import React from "react";
import MUILinearProgress from "@mui/material/LinearProgress";
import styles from "./linearProgress.module.scss";
const LinearProgress = ({ color = "primary", className, progress, }) => (React.createElement("div", { className: styles.container },
    React.createElement(MUILinearProgress, { className: className, color: color, title: "Loading", variant: progress !== undefined ? "determinate" : undefined, value: progress })));
export default LinearProgress;
//# sourceMappingURL=LinearProgress.js.map